<template>
	<div>
		<div class="row collapse">
			<div class="columns small-5 medium-4 text-center">
				<div class="switch round small">
				  <input :id="setting.title" type="radio" :name="setting.title" v-model="models[setting.title_setting]" :value="!!models[setting.title_setting]">
				  <label for="setting.title" v-on:click="toggleSetting(setting.title_setting)"></label>
				</div>			
			</div>
			<div class="columns small-6 medium-6">
				<h5>{{setting.title}}</h5>
			</div>
			<div class="columns small-1 medium-2 end">
				<LoadingSpinner :loading="loading" />
			</div>
		</div>


		<div class="row collapse" v-for="input in setting.inputs" v-if="models[setting.title_setting] == 'true' && !input.options">
			<div class="columns medium-3 large-2 medium-offset-2">
				<label class="field-label left inline" :for="input.setting">{{input.label}}</label>
			</div>

			<div class="columns medium-6">

				<!-- radio -->
				<div class="switch round tiny right" v-if="input.input_type == 'radio'">
				  <input :id="input.setting" type="radio" :name="input.setting" v-model="models[input.setting]" :value="!!models[input.setting]">
				  <label :for="input.setting" v-on:click="toggleSetting(input.setting)"></label>
				</div>	

				<!-- text -->
				<input v-else :type="input.input_type" :name="input.setting" :id="input.setting" v-model.trim="models[input.setting]" v-on:change.lazy="toggleSetting(input.setting)">
			</div>

			<div class="columns medium-1 end">
				<!-- <LoadingSpinner :loading="loading" /> -->
			</div>
		</div>

		<!-- select -->
		<div class="row">

			<div class="columns medium-3 large-2">
				&nbsp;
			</div>
			

			<div class="columns medium-6 large-4 end" v-if="models[setting.title_setting] == 'true' && input.options" v-for="input in setting.inputs">
				<label :for="input.setting">{{input.label}}</label>
				<select :name="input.setting" :id="input.setting" v-model="models[input.setting]" v-on:change="toggleSetting(input.setting)">
					<option value="null">Please select an option</option>
					<option :value="option.value" v-for="option in input.options">
						{{option.text}}
					</option>
				</select>
			</div>
		</div>






	</div>
</template>



<script>

import LoadingSpinner from './../LoadingSpinner';

import { mapGetters } from 'vuex';
export default {
	name: 'ClientPaymentSetting',
	data () {
		return  {
			loading: false,
			models: {
				
			}
		}
	},
	props: {
		'setting' : {
			type: Object,
			required: true
		}
	},
	computed : {
		...mapGetters([
			'paymentSettings'
		]),
	},

	methods: {
		createModels() {
			this.$set(this.models, this.setting.title_setting, this.paymentSettings[this.setting.title_setting]);
			for(let i = 0; i < this.setting.inputs.length; i++) {
				this.$set(this.models, this.setting.inputs[i].setting, this.paymentSettings[this.setting.inputs[i].setting])
			}
		},

		toggleSetting(setting) {
			this.loading = true;
			const value = this.getSettingValue((this.models[setting]));
			const payload = {
				setting: setting,
				value: value
			}
			this.$store.dispatch('UPDATE_SETTING', payload)
				.then( response => this.createModels())
				.then( () => this.loading = false);
		},

		getSettingValue (value) {
			if(value == "true") {
				return "false";
			} else if (value == "false") {
				return "true";
			} else {
				return value;
			}
		}
	},

	created () {
		this.createModels();
	},

	components: {
		LoadingSpinner
	}


}
	
</script>



<style scoped>
.field-label {
	font-size: 0.8rem;
}
	
</style>